import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { MatSelectChange } from '@angular/material/select';
import moment from 'moment';
import { DomSanitizer } from "@angular/platform-browser";
import { DownloadFileService } from "@shared/services/download-file.service";
import saveAs from "file-saver";

@Component({
  selector: "app-media",
  templateUrl: "./media.component.html",
  styleUrls: ["./media.component.scss"],
})
export class MediaComponent implements OnInit {
  pageUrl!: string;

  mediaList!: any[];

  mediaMap: any = {};

  selectedMediaId!: number;

  isMobileView = false;

  public inProgress: boolean = false;

  constructor(private apiService: ApiService,
    public sanitizer: DomSanitizer,
    public downloadFileService: DownloadFileService) { }

  ngOnInit() {
    this.pageUrl = location.href;
    this.readMedia();
  }

  public readMedia() {
    const obj = {
      type: "Media",
      year: "",
      month: ""
    };
    this.apiService.postData(Urls.readArticles, obj).subscribe(
      (response) => {
        response.data.articles.forEach((article: any) => {
          if (article.video) {
            const link = "https://www.youtube.com/embed/";
            if (article.video.startsWith('https://www.youtube.com/watch?')) {
              const embed = article.video.split("watch?v=")[1];
              article.video = link + embed;
            } else if (article.video.startsWith("https://youtu.be/")) {
              const embed = article.video.split("https://youtu.be/")[1];
              article.video = link + embed;
            }
          }
          const diff = moment(article.modifiedDate, "DD-MM-YYYY, h:mm:ss").fromNow();
          article.translatedModifiedDate = `${diff} . Updated`;
          this.mediaMap[article.id] = article;
        });
        this.mediaList = response.data.articles || [];

        if (this.mediaList[0]) {
          this.selectedMediaId = this.mediaList[0].id;
        }
      },
      (error) => { }
    );
  }

  public downloadAsPDF(media: any) {
    if (media) {
      const name = media.split("/").pop();
      this.inProgress = true;
      this.downloadFileService.export(media).subscribe(
        data => {
          this.inProgress = false;
          const url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();

        }, error => {
          this.inProgress = true;
        });
    }
  }
  public onSelectionChange(change: MatSelectChange) {
    this.selectedMediaId = change.value;
  }
  public getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public downloadFile(path: string, name: string) {
    this.downloadFileService.export(path).subscribe(
      data => saveAs(data, name + `.pdf`)
    );
  };

}
